export const error: any = {
  expiredTitle: "Page expired",
  errorMessageTitle: "An error has occurred",
  hotelNotFoundTitle: "No hotel found",
  hotelNotFoundDescription:
    "There are no hotels that match your search criteria. Please try again from the beginning with other search criteria.",
};
